document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.includes('/blogs/')) return;
    // अगर हम होम पेज ('/') पर हैं, तो स्क्रिप्ट को आगे न बढ़ाएं
    
    let loading = false;
    let page = 2;
    const productGrid = document.getElementById('main-collection-product-grid');
    const productItemClass = '.collection-template__product-item';

    if (!productGrid) return;

    const loader = document.getElementById('infinite-loader') || document.querySelector('.load-more');

    const loadMoreProducts = async () => {
        if (loading) return;
        loading = true;
        if (loader) loader.style.display = 'block';

        let currentParams = new URLSearchParams(window.location.search);
        currentParams.set('page', page);
        let fetchUrl = `${window.location.pathname}?${currentParams.toString()}`;

        try {
            const response = await fetch(fetchUrl);
            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const newProducts = doc.querySelectorAll(productItemClass);

            if (newProducts.length === 0) {
                if (loader) loader.innerText = 'No more products';
                loading = true; 
                return;
            }

            newProducts.forEach(item => {
                // --- DOUBLE REPEAT FIX START ---
                // Har product ka unique link ya ID nikaalein
                const productLink = item.querySelector('a')?.getAttribute('href');
                
                // Check karein ki kya ye link pehle se grid mein मौजूद hai?
                const isDuplicate = Array.from(productGrid.querySelectorAll('a')).some(existingLink => {
                    return existingLink.getAttribute('href') === productLink;
                });

                if (!isDuplicate) {
                    productGrid.appendChild(item.cloneNode(true));
                }
                // --- DOUBLE REPEAT FIX END ---
            });

            if (typeof reInitImages === "function") reInitImages();

            page++;
            loading = false;
            if (loader) loader.style.display = 'none';
        } catch (error) {
            console.error("Error:", error);
            loading = false;
        }
    };

    window.addEventListener('scroll', () => {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 800) {
            loadMoreProducts();
        }
    });
});